export default "./dist/stdassets/images/icons/preview.png";